import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

function Callback({ setIsAuthenticated }) {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      try {
        const response = await fetch(
          `${process.env.REACT_APP_FLASK_API}/callback`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ code }),
          }
        );

        if (response.ok) {
          setIsAuthenticated(true);
          navigate("/home");
        } else {
          const errorData = await response.json();
          setError(
            errorData.error || "Authentication failed. Please try again."
          );
        }
      } catch (error) {
        console.error("Error during authentication:", error);
        setError("Failed to complete authentication. Please try again later.");
      }
    };

    handleCallback();
  }, [navigate, setIsAuthenticated]);

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      <ClipLoader
        color="#c084fc"
        size={50}
      />
      <p className="ml-4 text-gray-300">Completing authentication...</p>
      {error && (
        <div className="mt-4 text-center">
          <p className="text-red-500">{error}</p>
          <button
            onClick={() => navigate("/")}
            className="mt-4 bg-purple-500 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded"
          >
            Try Again
          </button>
        </div>
      )}
    </div>
  );
}

export default Callback;
